import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import classes from "./Modal.module.scss";
import CrossIcon from "../Icons/CrossIcon";

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
  contentClassName?: string;
}

const Modal = ({ children, onClose, isOpen, contentClassName }: ModalProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    if (!isOpen) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isOpen]);

  if (!isOpen || !mounted) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  return createPortal(
    <div className={classes["backdrop"]} onClick={handleBackdropClick}>
      <div className={contentClassName ?? classes["modal-container"]} onClick={(e) => e.stopPropagation()}>
        <div className={classes["close-button-container"]} onClick={onClose}>
          <button className={classes["close-button"]}>
            <CrossIcon width={12} height={12} />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
